module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/coffee_a7d970.jpg";